/**
 * Utility functions for handling authentication errors
 */

/**
 * Checks if an error is an authentication error (401 or 403) and redirects to login
 * @param error - The error to check
 * @returns true if auth error was detected and redirect initiated
 */
export const handleAuthError = (error: any): boolean => {
  const isAuthError = error?.status && [401, 403].includes(error.status);
  
  if (isAuthError) {
    console.log('🔄 Auth error detected, redirecting to login:', {
      status: error.status,
      message: error.message || 'Authentication failed'
    });
    
    localStorage.removeItem("access_token");
    window.location.href = "/login";
    return true;
  }
  
  return false;
};

/**
 * Checks if user appears to be logged in (has token) but might have invalid token
 * @returns true if potentially logged in with invalid token
 */
export const isPotentiallyLoggedInWithInvalidToken = (): boolean => {
  const hasToken = localStorage.getItem("access_token") !== null;
  return hasToken;
};